(function () {
  'use strict';

  /* @ngdoc object
   * @name vcutils.vcshare
   * @description
   *
   */
  angular
    .module('vcutils.vcshare', [
    ]);
}());
